import {
  FaBoxOpen,
  FaHeart,
  FaShoppingBag,
  FaSignOutAlt,
  FaTimes,
  FaUserShield,
} from "react-icons/fa";
import "../App.css";

function UserDashboard({ user, cartCount, wishlistCount, onClose, onLogout }) {
  const displayName = user.displayName || user.email?.split("@")[0] || "User";

  return (
    <div className="account-overlay">
      <section className="account-panel" aria-label="User dashboard">
        <button className="account-close-btn" type="button" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="account-hero">
          <div className="account-header">
            <div className="account-avatar">
              {displayName.charAt(0).toUpperCase()}
            </div>
            <div>
              <p>Welcome back</p>
              <h2>{displayName}</h2>
              <span>{user.email}</span>
            </div>
          </div>

          <span className="account-status">
            <FaUserShield />
            Verified Customer
          </span>
        </div>

        <div className="account-stats">
          <div>
            <FaShoppingBag />
            <strong>{cartCount}</strong>
            <span>Cart Items</span>
          </div>
          <div>
            <FaHeart />
            <strong>{wishlistCount}</strong>
            <span>Wishlist</span>
          </div>
          <div>
            <FaBoxOpen />
            <strong>0</strong>
            <span>Orders</span>
          </div>
        </div>

        <div className="account-summary">
          <div>
            <span>Membership</span>
            <strong>Glow Insider</strong>
          </div>
          <div>
            <span>Next Benefit</span>
            <strong>Free skincare consultation</strong>
          </div>
        </div>

        <div className="account-actions">
          <a href="#/shop" onClick={onClose}>
            Continue Shopping
          </a>
          <a href="#/contact" onClick={onClose}>
            Help Center
          </a>
          <button className="account-logout-btn" type="button" onClick={onLogout}>
            <FaSignOutAlt />
            Logout
          </button>
        </div>
      </section>
    </div>
  );
}

export default UserDashboard;
